export default "__VITE_ASSET__C1w483fR__"